/*
  The club CTAs (snippets/frey-ranch-club-cta.liquid) are plain links to a chained cart URL:
  /cart/clear?return_to=/cart/add?...%26return_to=/checkout - one navigation that empties the
  cart, adds the membership with its selling plan, and lands on checkout. Pasted into the
  address bar that URL works on its own; this script exists purely to make a *click* on it
  behave the same way.

  Rebuy Smart Cart delegates click handling from `document` in the capture phase and stops
  propagation on any link pointing at /cart, opening its flyout instead of navigating. A
  listener on the anchor itself never runs - the event is killed before it gets there, which
  is why clicking these CTAs used to pop an empty cart drawer and go nowhere.

  Capture on `window` runs before `document` in the capture chain, so this gets the click
  first, kills it outright with stopImmediatePropagation, and navigates. Delegating (rather
  than binding per anchor) also covers CTAs that appear after load.

  Deliberately no fetch: Rebuy patches fetch, and both it and Dawn's drawer pop open on an
  AJAX cart mutation. A plain navigation gives them nothing to react to.
*/
/* Coming back from checkout restores this page from the back/forward cache exactly as it
   was left - mid-click, with the button still in its busy state and the spinner turning.
   pageshow fires on that restore (and on a normal load, where this is a no-op), so clear
   the busy state there. Not gated on event.persisted: some browsers restore visual state
   without setting it. */
window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-frey-ranch-checkout]').forEach((trigger) => {
    trigger.removeAttribute('aria-busy');
    const spinner = trigger.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.add('hidden');
  });
});

window.addEventListener(
  'click',
  (event) => {
    /* Let the browser handle anything that is not a plain left click - modifier and
       middle clicks mean "open elsewhere", and hijacking them would break that. */
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const node = event.target instanceof Element ? event.target : null;
    const trigger = node && node.closest('[data-frey-ranch-checkout]');
    if (!trigger) return;

    /* getAttribute, not .href: the property returns the URL parser's normalised form,
       which can percent-encode the items[][id] brackets. Shopify needs the raw bracket
       syntax to read the parameters as an array. */
    const target = trigger.getAttribute('href');
    if (!target || target === '#') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (trigger.hasAttribute('aria-busy')) return;
    trigger.setAttribute('aria-busy', 'true');

    const spinner = trigger.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    /* Navigating synchronously can beat the browser to painting the busy state, leaving
       a blank button for the whole redirect. Two frames: the first runs before paint,
       the second after it, so the spinner is on screen before the page starts leaving. */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.location.href = target;
      });
    });
  },
  true
);
